import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import {
  selectAssistantValue,
  selectSwitchedDialogs,
} from "../../../redux/selectors";
import { AppSwitch } from "../../../../../shared/components/AppSwitch";
import styles from "./styles.module.css";
import { useUpdateStorageValue } from "../../../../../app/state/storageObjectSlice/hook/use-update-storage-value";
import { setAssistantValue } from "../../../redux/slice";
import { getUpdatedValue } from "../../../helpers/getUpdatedValue";

export const DialoguesSwitcher = () => {
  const assistantValue = useAppSelector(selectAssistantValue);
  const isShowDialogs = useAppSelector(selectSwitchedDialogs);
  const { saveValue } = useUpdateStorageValue("assistants", setAssistantValue);
  const { t } = useTranslation();

  const handleDialoguesSwitch = (event: ChangeEvent<HTMLInputElement>) => {
    if (!assistantValue?.assistant_object) return;
    const newValue = getUpdatedValue(assistantValue, {
      metadata: {
        ...assistantValue.assistant_object?.metadata,
        dialogs: String(event.target.checked),
      },
    });
    saveValue(newValue);
  };

  return (
    <div className={styles["flex-container"]}>
      <AppSwitch checked={isShowDialogs} onChange={handleDialoguesSwitch} />
      {t("assistants.dialog_toggle")}
    </div>
  );
};
